import { GetAllUsers } from '~/domain/usecases/users/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
} from '~/domain/errors';

export class RemoteGetAllUsers implements GetAllUsers {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetAllUsers.Model>;

  constructor(url: string, httClient: HttpClient<GetAllUsers.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  getAll = async (params: GetAllUsers.Params): Promise<GetAllUsers.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
